import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=dd421872&scoped=true"
import script from "./integralDetails.vue?vue&type=script&lang=ts"
export * from "./integralDetails.vue?vue&type=script&lang=ts"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=dd421872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd421872",
  null
  
)

export default component.exports